import React from 'react';
import {Row, Col, Form, Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import Card from "../../../Card";
import {all_targets} from "../targets";
import cookie from "react-cookies";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class StandardConfigure extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            distance: 5,
            distanceToProjector: 0,
            heightOfTargetArea: 0,
            selectedTarget: null,
            useDistance: false,
            useTimer: false,
            twoPlayer: false,
            timerType: "running"
        }

        const config = cookie.load("scaleConfig")
        if (!!config) {
            this.state = {...this.state, ...config}
        }

    }

    saveSettings() {
        if (this.state.useDistance) {
            let config = {
                distanceToProjector: this.state.distanceToProjector,
                heightOfTargetArea: this.state.heightOfTargetArea
            }
            cookie.save("scaleConfig", config)
        }
        this.props.saveSettings(this.state)
    }

    render() {
        return (
            <>
                <Row>
                    <Col sm={12} md={{span: 8, offset: 2}}>
                        <Card>
                            <h5 style={{textDecoration: "underline"}}>설정</h5>
                            <Form inline>
                                <Form.Check
                                    type="switch"
                                    label="거리에 따른 표적 크기"
                                    id="custom-switch"
                                    checked={this.state.useDistance}
                                    onChange={(e) => {this.setState({useDistance: e.target.checked})}}
                                    inline
                                    style={{marginRight: "2px"}}
                                />

                                <OverlayTrigger
                                    placement={"bottom"}
                                    overlay={
                                        <Tooltip id={`info-tooltip`}>
                                            이 옵션을 선택하면 Take Aim이 특정 거리에 있는 것처럼 표적을 표시할 수 있습니다. 투사된 표적 영역의 높이와 프로젝터까지의 거리를 사용하여 Take Aim은 표적을 표시할 크기를 계산할 수 있습니다.
                                        </Tooltip>
                                    }
                                >
                                    <FontAwesomeIcon icon={faInfoCircle} style={{marginRight: "1rem"}}/>
                                </OverlayTrigger>
                                <Form.Check
                                    type="switch"
                                    label="사격 타이머 사용"
                                    id="custom-switch2"
                                    checked={this.state.useTimer}
                                    onChange={(e) => {this.setState({useTimer: e.target.checked})}}
                                    inline
                                />

                                <Form.Check
                                    type="switch"
                                    label="2인용 분할 화면"
                                    id="custom-switch3"
                                    checked={this.state.twoPlayer}
                                    onChange={(e) => {this.setState({twoPlayer: e.target.checked})}}
                                    inline
                                />
                            </Form>
                            {this.state.useDistance &&
                                <>
                                    <hr  style={{borderTop: "1px solid white"}}/>
                                    <Form.Group style={{marginTop: "0px", marginBottom: 0}}>
                                    <Form.Label>표적으로부터의 거리 (단위: 야드)</Form.Label>
                                    <Form.Control value={this.state.distance} onChange={(e) => {this.setState({distance: e.target.value})}} type={"number"} />
                                </Form.Group>
                                <hr  style={{borderTop: "1px solid white"}}/>
                                <p style={{marginBottom: 0}}>표적 크기를 정확하게 표현하기 위해 필요한 측정값은 다음과 같습니다:</p>
                                    <Form.Group>
                                        <Form.Label>화면과의 거리 (단위: 인치)</Form.Label>
                                        <Form.Control  value={this.state.distanceToProjector} onChange={(e) => {this.setState({distanceToProjector: e.target.value})}} type={"number"}/>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>표적 영역의 높이 (단위: 인치)</Form.Label>
                                        <Form.Control  value={this.state.heightOfTargetArea}
                                                       onChange={(e) => {this.setState({heightOfTargetArea: e.target.value})}}
                                                       type={"number"}/>
                                    </Form.Group>
                                </>
                            }
                            {this.state.useTimer &&
                                <>
                                    <hr  style={{borderTop: "1px solid white"}}/>
                                    <p style={{marginBottom: 0}}>타이머 유형</p>
                                    <Form inline>
                                        <Form.Check
                                            type={"radio"}
                                            label={"연속 타이머"}
                                            checked={this.state.timerType === "running"}
                                            inline
                                            style={{marginRight: "2px"}}
                                            onChange={() => {this.setState({timerType: "running"})}}
                                        />
                                        <OverlayTrigger
                                            placement={"bottom"}
                                            overlay={
                                                <Tooltip id={`info-tooltip`}>
                                                    연속 타이머는 초기 신호음 1회 이후 발사되는 모든 사격의 시간을 계속해서 측정합니다.
                                                </Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} style={{marginRight: "1rem"}}/>
                                        </OverlayTrigger>
                                        <Form.Check
                                            type={"radio"}
                                            label={"사이클 타이머"}
                                            checked={this.state.timerType === "cycle"}
                                            inline
                                            style={{marginRight: "2px"}}
                                            onChange={() => {this.setState({timerType: "cycle"})}}
                                        />
                                        <OverlayTrigger
                                            placement={"bottom"}
                                            overlay={
                                                <Tooltip id={`info-tooltip`}>
                                                    사이클 타이머는 초기 신호음 이후, 한 발의 사격을 측정한 다음 다시 처음부터 시작합니다. 홀스터에서 총을 꺼내는 연습을 할 때 유용합니다.
                                                </Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} style={{marginRight: "1rem"}}/>
                                        </OverlayTrigger>
                                    </Form>
                                </>
                            }
                        </Card>
                    </Col>
                </Row>
                <Row style={{marginTop: "20px"}}>
                    <Col sm={12} md={{span: 8, offset: 2}}>
                        <Card>
                            <h5 style={{textDecoration: "underline"}}>타겟 선택</h5>
                            <table>
                                <tbody>
                                    {all_targets.filter(a => a.stationary === true).map((value, key) => {
                                        return (
                                            <tr key={key} >
                                                <td>
                                                    <span style={{fontWeight: "bold"}}>명칭: </span>{value.displayName}
                                                </td>
                                                <td className={"text-center"}>
                                                    <img src={"/assets/targets/" + value.fileName} style={{height: "200px", marginTop: "30px"}}/>
                                                </td>
                                                <td className={"text-center"}>
                                                    {this.state.selectedTarget === value.name ?
                                                        <p>선택됨</p>
                                                        :
                                                        <Button variant="customPrimary" onClick={() => {this.setState({selectedTarget: value.name})}}>이 타겟 선택</Button>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </Card>
                    </Col>
                </Row>
                <Row style={{marginTop: "20px"}}>
                    <Col sm={12} className={"text-center"}>
                        <Button variant={"customPrimary"} onClick={() => {this.saveSettings()}} disabled={this.state.selectedTarget === null} size={"lg"}>사격 시작</Button>
                    </Col>
                </Row>

            </>
        )
    }
}

export default StandardConfigure;